<template>
  <div class="preload">
    <div class="sk-cube-grid">
      <div class="sk-cube sk-cube1"></div>
      <div class="sk-cube sk-cube2"></div>
      <div class="sk-cube sk-cube3"></div>
      <div class="sk-cube sk-cube4"></div>
      <div class="sk-cube sk-cube5"></div>
      <div class="sk-cube sk-cube6"></div>
      <div class="sk-cube sk-cube7"></div>
      <div class="sk-cube sk-cube8"></div>
      <div class="sk-cube sk-cube9"></div>
    </div>
    <div>
      <h1 class="texto_centrado">Cargando...</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "preload"
};
</script>

<style scoped>
.preload {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #ccc;
  z-index: 8000;
  padding-top: 100px;
}

.sk-cube-grid {
  width: 65px;
  height: 65px;
}

.texto_centrado {
  text-align: center;
}
</style>